export const ORDERS_DEMO = [
  {
    id: 'ord_01', orderNumber: 'ORD-MOXBTC7H-V4XJ',
    status: 'processing', paymentStatus: 'paid',
    total: '240000', subtotal: '240000', tax: '0', shippingCost: '0', discountAmount: '0',
    paymentMethod: 'epayco', currency: 'COP',
    guestEmail: 'cliente1@gmail.com', guestName: 'Sebastián Lozano',
    shippingAddress: { fullName: 'Sebastián Lozano', addressLine1: 'Calle 167 #16B-44', city: 'Bogotá', state: 'Bogotá D.C.', country: 'CO', phone: '3213613163' },
    createdAt: '2026-05-08T14:35:00.000Z', updatedAt: '2026-05-08T14:42:00.000Z',
    itemCount: 1,
  },
  {
    id: 'ord_02', orderNumber: 'ORD-MOXC84JB-YCON',
    status: 'pending', paymentStatus: 'pending',
    total: '295000', subtotal: '295000', tax: '0', shippingCost: '0', discountAmount: '0',
    paymentMethod: 'epayco', currency: 'COP',
    guestEmail: 'cliente2@gmail.com', guestName: 'María Ortiz',
    shippingAddress: { fullName: 'María Ortiz', addressLine1: 'Cra 7 #45-12', city: 'Medellín', state: 'Antioquia', country: 'CO', phone: '3001234567' },
    createdAt: '2026-05-08T13:10:00.000Z', updatedAt: '2026-05-08T13:10:00.000Z',
    itemCount: 1,
  },
  {
    id: 'ord_03', orderNumber: 'ORD-MOXCA06Y-LYLU',
    status: 'shipped', paymentStatus: 'paid',
    total: '430000', subtotal: '430000', tax: '0', shippingCost: '0', discountAmount: '0',
    paymentMethod: 'bold', currency: 'COP',
    guestEmail: 'andres@example.com', guestName: 'Andrés Pérez',
    shippingAddress: { fullName: 'Andrés Pérez', addressLine1: 'Av Circunvalar #80-32', city: 'Cali', state: 'Valle del Cauca', country: 'CO', phone: '3014567890' },
    createdAt: '2026-05-07T16:00:00.000Z', updatedAt: '2026-05-08T09:00:00.000Z',
    shippedAt: '2026-05-08T09:00:00.000Z',
    trackingNumber: 'COORDI-998877',
    itemCount: 1,
  },
  {
    id: 'ord_04', orderNumber: 'ORD-MOX9XL2P-FFFF',
    status: 'delivered', paymentStatus: 'paid',
    total: '195000', subtotal: '195000', tax: '0', shippingCost: '0', discountAmount: '0',
    paymentMethod: 'bold', currency: 'COP',
    guestEmail: 'lina@example.com', guestName: 'Lina Castro',
    shippingAddress: { fullName: 'Lina Castro', addressLine1: 'Calle 26 #14-33', city: 'Bogotá', state: 'Bogotá D.C.', country: 'CO', phone: '3201112233' },
    createdAt: '2026-05-05T11:00:00.000Z', updatedAt: '2026-05-07T15:00:00.000Z',
    shippedAt: '2026-05-06T10:00:00.000Z',
    deliveredAt: '2026-05-07T15:00:00.000Z',
    itemCount: 1,
  },
  {
    id: 'ord_05', orderNumber: 'ORD-MOX8XL2P-GGGG',
    status: 'cancelled', paymentStatus: 'failed',
    total: '410000', subtotal: '410000', tax: '0', shippingCost: '0', discountAmount: '0',
    paymentMethod: 'epayco', currency: 'COP',
    guestEmail: 'cancel@example.com', guestName: 'Pago Rechazado',
    shippingAddress: { fullName: 'Pago Rechazado', addressLine1: 'Calle 50 #10-20', city: 'Bogotá', state: 'Bogotá D.C.', country: 'CO', phone: '3009998877' },
    createdAt: '2026-05-04T18:00:00.000Z', updatedAt: '2026-05-04T18:30:00.000Z',
    itemCount: 1,
  },
  {
    id: 'ord_06', orderNumber: 'ORD-MOX7XL2P-HHHH',
    status: 'processing', paymentStatus: 'paid',
    total: '275000', subtotal: '275000', tax: '0', shippingCost: '0', discountAmount: '0',
    paymentMethod: 'epayco', currency: 'COP',
    guestEmail: 'sofia@example.com', guestName: 'Sofía Rodríguez',
    shippingAddress: { fullName: 'Sofía Rodríguez', addressLine1: 'Calle 100 #45-67', city: 'Barranquilla', state: 'Atlántico', country: 'CO', phone: '3002345678' },
    createdAt: '2026-05-03T20:00:00.000Z', updatedAt: '2026-05-04T08:00:00.000Z',
    itemCount: 2,
  },
]

export const ORDER_DETAIL_DEMO = {
  ...ORDERS_DEMO[0],
  items: [
    {
      id: 'oi_01', productId: 'prd_02', variantId: 'var_02e', quantity: 1,
      price: '240000', taxRate: '0', taxAmount: '0',
      productSnapshot: {
        productId: 'prd_02',
        name: 'Long Sleeve "Somnolencia"',
        description: 'Una pieza que representa ese estado entre la vigilia y el sueño\n\n100% algodón premium\nGramaje: 260 g/m²',
        sku: 'EUTANASIA_02',
        images: ['https://picsum.photos/seed/ls2/200'],
        variant: { name: 'XXL', sku: 'EUTANASIA_02-XXL', attributes: { size: 'XXL' } },
      },
    },
  ],
  transactions: [
    { id: 'tx_01', amount: '240000', currency: 'COP', status: 'completed', providerTransactionId: '365648722', createdAt: '2026-05-08T14:42:00.000Z' },
  ],
}
